import {
  PLATFORM_ENDPOINT as _PLATFORM_ENDPOINT,
  APP_POSTHOG_API_KEY as _APP_POSTHOG_API_KEY,
  APP_POSTHOG_PROXY_ENDPOINT as _APP_POSTHOG_PROXY_ENDPOINT,
  ENVIRONMENT as _ENVIRONMENT,
} from "./secrets";

export const PLATFORM_ENDPOINT = _PLATFORM_ENDPOINT ?? "";
export const POSTHOG_API_KEY = _APP_POSTHOG_API_KEY ?? "";
export const POSTHOG_PROXY_ENDPOINT = _APP_POSTHOG_PROXY_ENDPOINT ?? "";
export const ENVIRONMENT = _ENVIRONMENT ?? "";
